<template>
  <div>
    <!-- 业财一体化——销售交接实施方案 <ID1095743> -->
    <iframe v-if="EOSLayoutShow" class="entry-eos-layout" :src="EOSUrl" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      EOSLayoutShow: this.$route.query.EOSProjectCode,
      EOSUrl: `${process.env.VUE_APP_EOS_URL}/#/nested-pages/pc/customer-survey-form?EOSProjectCode=${this.$route.query.EOSProjectCode}`
    }
  }
}
</script>

<style lang="less" scoped>
.entry-eos-layout {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  border: 0;
  z-index: 99999;
}
</style>
